export default [
  "Hair & Make Up",
  "Hair & Grooming",
  "Make Up",
  "Hair",
  "Style",
  "Nails",
  "Set Design",
  "Green Creator",
  "Fashion Shows",
  "Art Direction",
  "Colorist",
  "Talent",
  "Education",
];
export const excludeFromMenu = [
  "Hair & Grooming",
  "Colorist",
  "Make Up",
  "Hair",
  "Education",
];
export const addToHairMakeUp = ["Hair", "Colorist"];
